var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0175 17.2473C22.8301 17.2473 20.2397 19.8377 20.2397 23.0251V25.8081C20.2397 26.3955 19.9894 27.291 19.6908 27.7918L18.5834 29.631C17.8997 30.7673 18.3716 32.0288 19.6234 32.4525C23.7738 33.8392 28.2516 33.8392 32.4019 32.4525C33.5671 32.0673 34.0775 30.6903 33.4419 29.631L32.3345 27.7918C32.0456 27.291 31.7953 26.3955 31.7953 25.8081V23.0251C31.7953 19.8473 29.1953 17.2473 26.0175 17.2473Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7993 17.5253C27.5008 17.4387 27.1926 17.3713 26.8748 17.3328C25.9504 17.2172 25.0645 17.2846 24.2363 17.5253C24.5156 16.8128 25.2089 16.312 26.0178 16.312C26.8267 16.312 27.52 16.8128 27.7993 17.5253Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9086 32.7991C28.9086 34.388 27.6086 35.688 26.0197 35.688C25.2301 35.688 24.4983 35.3606 23.9783 34.8406C23.4583 34.3206 23.1309 33.5887 23.1309 32.7991",
    stroke: "#6B6B6B",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiside);
export default __webpack_public_path__ + "static/media/notiside.7c71a2f3daf087df24e87b1e7681f165.svg";
export { ForwardRef as ReactComponent };